/**
 * Retrieves an object with global default settings
 *
 * @return {object} Default settings object containing:
 * - defaultSystemPrompt: The default prompt for the assistant.
 * - defaultConversationName: The default name for a new conversation.
 * - useRagByDefault: A boolean indicating whether RAG (Red, Amber, Green) is used by default.
 */
export default function getDefaults() {
  return {
    defaultSystemPrompt:
      "You are a friendly and helpful assistant.\n\n" +
      "You are able to respond with markdown formatted replies to user messages.\n\n" +
      "Files may be attached to the user's messages, in which case they will be converted into plain text for you to analyze.\n\n" +
      "If you have sent a message with a Markdown formatted image in it, go ahead and take credit for generating it, as another AI model was brought in to fulfill that request. Feel free to use that image's description to describe the image if relevant.",
    defaultConversationName: "New Conversation",
    useRagByDefault: false,
  };
}
